<script lang="ts">
    import { onMount } from "svelte";
    import Role from "../../Models/Role";
    import Select from 'svelte-select';       
    import Employee from "../../Models/Employee";

    export let defaultOption = null;
    export let disabled: boolean = false;
    export let styles: string = "";

    let items;
    let value = {label: '', value: null};

    onMount(async () => {
        if (defaultOption) value = defaultOption;
        const res = await Role.get();
        items = res.map(role => {
            return {
                label: role.name,
                value: role._id
            }
        });
    });
</script>

{#if items}
    <Select on:select bind:value isDisabled={disabled} {items} listOutsideParentContainer placeholder="Wybierz rolę pracownika" containerStyles="padding: 0.4em; height: 2.25em; {styles}" isClearable={false} inputStyles="padding: 0.4em;"></Select>
    <input type="hidden" name="role" bind:value={value.value}>
{/if}